function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 8
});

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 21,
  y1: 21,
  x2: 16.65,
  y2: 16.65
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#9b9b9b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/search.39d89974.svg";
export { SvgComponent as ReactComponent };